module.exports = __webpack_public_path__ + "img/insta.ffb60108.svg";